import { useState, useEffect, useCallback } from "react";

const useFetchAllDataByID = (apiCall, params = null) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [refetchFlag, setRefetchFlag] = useState(false);

  const fetchData = useCallback(async () => {
    if (typeof apiCall !== "function") return;
    if (!params) {
      setData([]);
      return;
    }

    setLoading(true);
    setError(null);

    try {
      const response = await apiCall(params);

      if (response?.data?.success) {
        setData(response.data.data ?? []);
      } else {
        setData([]);
      }
    } catch (err) {
      console.error("useFetchAllDataByID error:", err);
      setError(err);
    } finally {
      setLoading(false);
    }
  }, [apiCall, params]);

  useEffect(() => {
    fetchData();
  }, [fetchData, refetchFlag]);

  const refetch = () => setRefetchFlag(prev => !prev);

  return { data, loading, error, refetch };
};

export default useFetchAllDataByID;
